/* eslint-disable react/jsx-no-useless-fragment */
import * as Tooltip from '@radix-ui/react-tooltip';
import { TooltipContent } from '@radix-ui/react-tooltip';
import { StyledTooltipArrow, StyledTooltipContent, StyledTooltipText } from './tool-tip.styles';
import type { ToolTipProps } from './tool-tip.types';
export const ToolTip = ({
  children,
  toolTipText,
  side = 'top',
  $contentMaxWidth,
  $fontSize,
  $textAlign,
  disabled = false,
  sideOffset = 5,
  useStyledContent = true,
  open,
  ...tooltipProviderProps
}: ToolTipProps) => {
  if (disabled) return <>{children}</>;
  return <Tooltip.Provider {...tooltipProviderProps} delayDuration={300} data-sentry-element="unknown" data-sentry-component="ToolTip" data-sentry-source-file="tool-tip.tsx">
      <Tooltip.Root open={open} data-sentry-element="unknown" data-sentry-source-file="tool-tip.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="tool-tip.tsx">{children}</Tooltip.Trigger>
        <Tooltip.Portal data-sentry-element="unknown" data-sentry-source-file="tool-tip.tsx">
          {useStyledContent ? <StyledTooltipContent sideOffset={sideOffset} side={side} $contentMaxWidth={$contentMaxWidth}>
              <StyledTooltipText $fontSize={$fontSize} $textAlign={$textAlign}>
                {toolTipText}
              </StyledTooltipText>
              <StyledTooltipArrow />
            </StyledTooltipContent> : <TooltipContent side={side} sideOffset={sideOffset} role="tooltip">
              {toolTipText}
              <StyledTooltipArrow />
            </TooltipContent>}
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>;
};